<template>
  <div class="wizard-progress-bar">
    <template v-for="(step, index) in steps">
      <div
        :key="'step-' + index"
        class="wizard-step"
        :class="{
          'wizard-step--current': currentStep === index + 1,
          'wizard-step--active': currentStep > index + 1,
          'wizard-step--inactive': currentStep < index + 1,
          'wizard-step--clickable': canClickStep(index + 1)
        }"
        @click="onStepClick(index + 1)"
      >
        <div class="wizard-step__indicator">
          <span>{{ index + 1 }}</span>
        </div>
        <span class="wizard-step__label">{{ step }}</span>
      </div>
      <!-- <div v-if="index < steps.length - 1" :key="'connector-' + index" class="wizard-connector"
        :class="{ 'wizard-connector--active': currentStep > index + 1 }">
      </div> -->
      <div class="wizard-separator" :class="{'last-separator': index === steps.length -1 }"></div>
    </template>
  </div>
</template>

<script>
export default {
  name: "WizardProgressBar",
  props: {
    steps: {
      type: Array,
      required: true,
    },
    currentStep: {
      type: Number,
      required: true,
    },
    maxClickableStep: {
      type: Number,
      default: 1,
    },
    navigationDisabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    canClickStep(step) {
      return !this.navigationDisabled && step !== this.currentStep && step <= this.maxClickableStep;
    },
    onStepClick(step) {
      if (this.canClickStep(step)) {
        this.$emit("step-click", step);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.wizard-progress-bar {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  gap: 0;
}

.wizard-step {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
  padding: 0px 24px 0 0;
  cursor: default;
  transition: all 0.3s ease;
  user-select: none;
  color: #999;
}

.wizard-step--current {
  color: #fff;
}

.wizard-step--active {
  color: #fff;
}

.wizard-step--clickable {
  cursor: pointer;
}

// .wizard-step--active:hover {
//   background-color: #225527;
// }

.wizard-step--inactive {
  color: #aaa;
}

.wizard-step__indicator {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 1rem;
  span{
    font-size: 1rem;
    font-variant-numeric: lining-nums tabular-nums;
  }
}

.wizard-step--current .wizard-step__indicator {
  background-color: var(--wf-primary);
  color: #fff;
}

.wizard-step--active .wizard-step__indicator {
  background-color: rgba(255, 255, 255, 0.2);
  color: #fff;
}

.wizard-step--inactive .wizard-step__indicator {
  background-color: #666666;
  color: #CBCBCB;
}

.wizard-step__label {
  font-size: 1.3rem;
  font-weight: 500;
  letter-spacing: 0.3px;
}

.wizard-connector {
  width: 50px;
  height: 2px;
  background-color: #ddd;
  transition: background-color 0.3s ease;
}

.wizard-connector--active {
  background-color: #2d6b31;
}

.wizard-separator{
  width: 1px;
  background-color: #666666;
  height: 85px;
  margin: 0 20px;
}
.wizard-separator.last-separator{
  margin: 0 20px 0 85px;
}
</style>
